export default __webpack_public_path__ + "images/logo_JESA_transparent-white-bottom_v02.webp?b2326e5e8d3e871c0648dfc18cb49450";